import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import competencies from 'modules/competencies/store/collections/competencies'
import competencyOptions from 'modules/competencies/store/collections/competencyOptions'

// Dear dev, right now this hook is used to obtain the competencies
// for each page that needs to show the competencies assessments
// this pages are not below a single component, that's why every page
// will need to make this call. After this is refactored to graphql
// this hook can be changed to obtain a questionGroupId and fetch
// the competencies and options from graphql and use those fetch data
// for the components insteead of the mobx models
export function useQuestionGroupCompetencies(competenciesEnabled: boolean) {
  const { loading } = useAsyncData(() => {
    if (!competenciesEnabled) {
      return Promise.resolve()
    }

    return Promise.all([competencies.fetch(), competencyOptions.fetch()])
  }, [])

  return {
    loading,
  }
}
